/* VIZZYO: preserve Judge.me's native tab panels; bridge older widget markup only. */
(() => {
  'use strict';
  if (window.VzyJudgeMeAccessibility) {
    window.VzyJudgeMeAccessibility.scan();
    return;
  }
  const controllers = new Map();
  const marker = 'data-vzy-jdgm-a11y';
  let discovery;
  let discoveryTimeout;

  function mount(widget) {
    if (controllers.has(widget)) return;
    let frame = 0;
    const owned = () => Array.from(widget.querySelectorAll('[' + marker + ']'));
    function sync() {
      frame = 0;
      if (!widget.isConnected) return;
      const tabs = Array.from(widget.querySelectorAll('[role="tab"][aria-controls]'));
      if (!tabs.length) return;
      const active = tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0];
      const activeId = active.getAttribute('aria-controls');
      const nativePanels = Array.from(widget.querySelectorAll('[role="tabpanel"][id]'))
        .filter(panel => !panel.hasAttribute(marker));
      const nativeIds = new Set(nativePanels.map(panel => panel.id));
      const tabIds = new Set(tabs.map(tab => tab.getAttribute('aria-controls')));

      // Only remove attributes/nodes created by this bridge. Vue owns native panels.
      owned().forEach(panel => {
        if (panel.getAttribute(marker) === 'placeholder') {
          if (nativeIds.has(panel.id) || !tabIds.has(panel.id)) panel.remove();
        } else if (nativePanels.length || panel.id !== activeId) {
          ['id', 'role', 'aria-labelledby', 'tabindex', marker].forEach(name => panel.removeAttribute(name));
        }
      });

      if (!nativePanels.length && activeId) {
        const content = widget.querySelector('.jdgm-tablist__content');
        // Do not claim a container carrying an unrelated application-owned ID.
        if (content && (!content.id || content.getAttribute(marker) === 'legacy-panel')) {
          owned().filter(panel => panel.id === activeId && panel.getAttribute(marker) === 'placeholder')
            .forEach(panel => panel.remove());
          content.id = activeId;
          content.setAttribute('role', 'tabpanel');
          content.setAttribute('aria-labelledby', active.id);
          content.setAttribute(marker, 'legacy-panel');
          content.tabIndex = 0;
        }
      }

      const ids = new Set(Array.from(widget.querySelectorAll('[id]')).map(node => node.id));
      tabs.forEach(tab => {
        const id = tab.getAttribute('aria-controls');
        if (!id || ids.has(id)) return;
        const panel = document.createElement('div');
        panel.id = id;
        panel.hidden = true;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tab.id);
        panel.setAttribute(marker, 'placeholder');
        widget.appendChild(panel);
        ids.add(id);
      });
    }
    const observer = new MutationObserver(() => {
      if (!frame) frame = requestAnimationFrame(sync);
    });
    observer.observe(widget, {childList:true, subtree:true, attributes:true,
      attributeFilter:['aria-selected', 'aria-controls']});
    controllers.set(widget, () => {
      observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
      controllers.delete(widget);
    });
    sync();
  }
  function scan() {
    controllers.forEach((destroy, widget) => { if (!widget.isConnected) destroy(); });
    document.querySelectorAll('#judgeme_product_reviews').forEach(mount);
    if (controllers.size && discovery) {
      discovery.disconnect();
      discovery = null;
      clearTimeout(discoveryTimeout);
    }
  }
  function discover() {
    scan();
    if (controllers.size || discovery) return;
    discovery = new MutationObserver(scan);
    discovery.observe(document.documentElement, {childList:true, subtree:true});
    discoveryTimeout = setTimeout(() => { discovery?.disconnect(); discovery = null; }, 30000);
  }
  document.addEventListener('shopify:section:load', discover);
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((destroy, widget) => {
      if (event.target === widget || event.target.contains(widget)) destroy();
    });
  });
  window.VzyJudgeMeAccessibility = {scan: discover};
  discover();
})();
